import { Button, Card, CircularProgress, Typography } from '@material-ui/core';
import { PhotoCamera } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { useCallback, useState } from 'react';
import { useNotify } from 'react-admin';
import {
  useQuizAssessmentTestDataProvider
} from '../../../../providers/data-provider/quiz-assessment-test.data.provider';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
  },
  label: {
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  input: {
    display: 'none',
  },
  fileName: {
    display: 'block',
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary,
    wordBreak: 'break-all',
  },
}));

export function AnswerSheetPhotoCard({ onAnswersExtracted }) {
  const classes = useStyles();
  const notify = useNotify();
  const { extractAnswersFromImage } = useQuizAssessmentTestDataProvider();
  const [photo, setPhoto] = useState(null);
  const [extracting, setExtracting] = useState(false);

  const handlePhotoChange = useCallback((evt) => {
    const inputEl = evt.target;
    const file = inputEl.files?.[0];
    if (!file) return;
    setPhoto(file);
    setExtracting(true);
    extractAnswersFromImage(file).then((res) => {
      onAnswersExtracted(res.data?.answers || []);
      notify('Respostas extraídas da imagem com sucesso.', 'info');
    }).catch(() => {
      notify('Não foi possível extrair as respostas da imagem.', 'warning');
    }).finally(() => {
      setExtracting(false);
      inputEl.value = '';
    });
  }, [extractAnswersFromImage, onAnswersExtracted, notify]);

  let buttonLabel = photo ? 'Trocar Foto' : 'Tirar Foto';
  if (extracting) buttonLabel = 'Extraindo respostas...';

  return (
    <Card className={classes.card}>
      <Typography variant="body2" className={classes.label}>
        Foto do gabarito preenchido
      </Typography>
      <input
        accept="image/*"
        capture="environment"
        className={classes.input}
        id="answer-sheet-photo-input"
        type="file"
        disabled={extracting}
        onChange={handlePhotoChange}
      />
      <label htmlFor="answer-sheet-photo-input">
        <Button
          component="span"
          variant="outlined"
          color="primary"
          fullWidth
          disabled={extracting}
          startIcon={extracting ? <CircularProgress size={18} color="inherit" /> : <PhotoCamera />}
        >
          {buttonLabel}
        </Button>
      </label>
      {photo && !extracting && (
        <Typography variant="caption" className={classes.fileName}>
          {photo.name}
        </Typography>
      )}
    </Card>
  );
}
